import styled from 'styled-components';
import { marginStyles } from '../../styles/components.js';

const StyledLabel = styled.label `
  align-items: center;
  color: ${props => props.theme.colors.content[props.color]};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'default')};
  display: flex;
  font-family: ${props => props.theme.fontFamilies.main[props.fontFamily]};
  -webkit-font-smoothing: antialiased;
  font-size: ${props => props.theme.fontSizes[props.fontSize]};
  line-height: ${props => props.theme.lineHeights[props.lineHeight]};
  opacity: ${props => props.disabled
    ? props.theme.opacities.low
    : props.theme.opacities[props.opacity]};
  width: fit-content;

  > sup {
    color: ${props => props.theme.colors.content.error};
  }

  ${props => marginStyles(props.margin)};
`;

export { StyledLabel };
